import {createContext} from 'react'

export const SizeContext = createContext<number>(2)
